// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8809 ? "700d6c82" : chunkId) + "." + {"1510":"ac2dd40630cdec77","5266":"d224f6be9e9fdc33","6432":"ef25beb51bdeaa0a","8083":"59010b82eb72dedf","8809":"709e321588e56998"}[chunkId] + ".js";
};